export const CARDS_PER_ROW = [
    {
      "cards": 1
    }
]

export const BREADCRUMB_ITEMS = [
    {
      "text": "Seller Lookup",
      "href": "/"
    }
]


// WEBPACK FOOTER //
// ./src/components/Seller/Lookup/SellerLookupConstants.jsx